import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { City } from 'src/app/_models/city.model';
import { AreaService } from 'src/app/_services/area.service';
import { ToastrService } from 'ngx-toastr';
import { Area } from 'src/app/_models/area.model';
import { showNotification } from 'src/app/helpers/show-toast';
import { CityService } from 'src/app/_services/city.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-area',
  templateUrl: './add-area.component.html',
  styleUrls: ['./add-area.component.scss'],
})
export class AddAreaComponent implements OnInit {
  pageTitle: string = 'Areas'
  cities: City[];
  editMode = false;

  area: Area = { name: '', enName: '', isActive: true, cityId: 0 };

  addAreaForm: FormGroup;
  isSubmited: boolean = false;

  constructor(
    private areaService: AreaService,
    private cityService: CityService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.addAreaForm = this._formBuilder.group({
      enAreaName: [null, [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)]],
      arAreaName: [null, [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .-]+$/)]],
      areaCity: [null, [Validators.required]],
      areaActiveCheck: [true, [Validators.required]],
    });

    const cityId = this.activatedRoute.snapshot.params.cityId;
    if (cityId) {
      this.area.cityId = cityId;
    }
    this.editMode =
      (this.activatedRoute.snapshot.url[2] &&
        this.activatedRoute.snapshot.url[2].path === 'edit' &&
        true) ||
      (this.activatedRoute.snapshot.url[1] &&
        this.activatedRoute.snapshot.url[1].path === 'edit' &&
        true);
    //

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.areaId;

      this.areaService.getAreaById(id).subscribe((res) => {
        this.area = res.data;

        this.addAreaForm.controls['enAreaName'].setValue(this.area.enName);
        this.addAreaForm.controls['arAreaName'].setValue(this.area.name);
        this.addAreaForm.controls['areaCity'].setValue(this.area.cityId);
        this.addAreaForm.controls['areaActiveCheck'].setValue(this.area.isActive);
      });
    }

    this.getActiveCities();
  }

  getActiveCities() {
    this.cityService.getAllCities().subscribe((res) => {
      this.cities = res.filter(item => item.isActive);
    });
  }

  onAddAreaSubmit() {
    this.isSubmited = true;

    this.area.enName = this.addAreaForm.value.enAreaName;
    this.area.name = this.addAreaForm.value.arAreaName;
    this.area.cityId = this.addAreaForm.value.areaCity;
    this.area.isActive = this.addAreaForm.value.areaActiveCheck;

    if (this.addAreaForm.valid) {
      if (this.editMode) {
        this.areaService.updateArea(this.area).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.enName} has been updated`,
            this.toastr
          );
          this.router.navigateByUrl('geo/areas');
        });
      } else {
        this.areaService.addArea(this.area).subscribe((res) => {
          showNotification(
            'success',
            `${res.data.enName} has been added`,
            this.toastr
          );

          this.router.navigateByUrl('geo/areas');
        });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }
}
